import { createTypes } from '../../utils/helpers';

export const PRODUCT_GROUP_TRANSLATIONS: any = createTypes(
  'PRODUCT_GROUP_TRANSLATIONS',
);
export const PRODUCT_GROUP_TRANSLATIONS_UPDATE: any = createTypes(
  'PRODUCT_GROUP_TRANSLATIONS_UPDATE',
);
